import { Component, Input } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { Objects } from "src/modules/utils/shared/objects";
import { Strings } from "src/modules/utils/shared/strings";
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { FrontendField } from '../../netgen/FrontendField';
import { FrontendFieldType } from '../../netgen/FrontendFieldType';
import { FrontendForm } from '../../netgen/FrontendForm';
import { GenericObjectDefinition } from '../../netgen/GenericObjectDefinition';

@Component({
    selector: 'admin-object-edit',
    templateUrl: './admin-object-edit.component.html',
    styleUrls: ['./admin-object-edit.component.scss'],
    standalone: false
})
export class AdminObjectEditComponent extends ComponentView {

    neededParams: ObjectOfSimpleDataTypes = { 
        scope: "string",
        id: "string",
        key: "string"
     };
    
    @Input()
    scope: string;
    @Input()
    id: string;
    @Input()    
    key: string;

    def: GenericObjectDefinition;
    data: any;
    
    form: FrontendForm;
    
    async initParams(): Promise<boolean> {
        this.fullScreenComponent = false;
        this.def = this.app.mainConfig.genericObjectDefinitions.find(item => item.scope == this.scope && item.id == this.id);
        this.data = await this.app.loadDataHandler(async () => RestEndpoint.main().query({key: this.key}).run(this.def.apiEndpoint).getObject(), this) ?? {};
        this.form = new FrontendForm([
            //TODO PRAGMATIC
            this.def.id == "locations" ? new FrontendField("label", "Name", FrontendFieldType.string, { enabled: false }) : null,
            ...this.def.attributes
        ]);
        for (let a of this.def.attributes) {
            if (a.type == FrontendFieldType.table) {
                let value = this.data[a.id];
                if (Strings.is(value) && (value as string).startsWith("[")) {
                    this.data[a.id] = Objects.fromJson(value);
                    //TODO PRAGMATIC
                    if (this.def.id == "adminGlobal" && a.id == "accountingCutOffDates") {
                        for (let item of this.data[a.id]) {
                            if (Strings.is(item.cutOffDate)) {
                                item.cutOffDate = new Date(item.cutOffDate);
                            }
                            if (Strings.is(item.period)) {
                                item.period = new Date(item.period);
                            }
                        }
                    }
                }
                if (value == null || !this._Arrays.is(this.data[a.id])) {
                    this.data[a.id] = [];
                }
            }
        }
        this.form.fill(this.data);

        this.app.updateNavigation(null, [
            { label: "Administration", routerLink: ["/base2", "admin"] },
            { label: this.def.title, routerLink: ["/base2", "admin", "generic-list", this.scope, this.id] },
            { label: this.data?.label, routerLink: ["/base2", "admin", "generic-list", this.scope, this.id, this.key] }
        ]);
        return true;
    }

    async saveInternal(): Promise<void> {
        this.form.get(this.data);
        await this.app.saveDataHandler(async () => RestEndpoint.main().query({key: this.key}).body(this.data).put().run(this.def.apiEndpoint).getText(), this, true, true);
    }

    cancel(): void {
        this.app.navigateBack();
    }
}